import { Component, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'lg-navbar',
  templateUrl: 'navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  selectedLang: string;
  langList: string[] = ['es', 'en', 'pt'];

  constructor(public translate: TranslateService) {
    translate.addLangs(this.langList);
    translate.setDefaultLang('es');

    const browserLang = translate.getBrowserLang();
    translate.use(browserLang);
    // translate.use(browserLang.match(/en|es/) ? browserLang : translate.getDefaultLang());
  }

  ngOnInit(): void {
    this.selectedLang = this.translate.currentLang;
  }
}
